import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  CycleCreateDto,
  CycleUpdateDto,
} from '../proxy/geographic/dtos/cycle';
import { CYCLE_CONFIG, CYCLE_FIELDS } from './cycle.config';
import {GenericForm, BaseHierarchicalCrudComponent, ICrudService, ZnHierarchicalViewComponent  } from '@zendra/shared';
import { CycleService } from '../proxy/geographic/controllers';
import { CycleProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  CycleProjectionDto,
  CycleProjectionExcelDownloadDto,
  GetCycleProjectionListInputDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/cycles/models';

@Component({
  selector: 'app-cycle',
  imports: [
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, CycleService, ConfirmationService],
  templateUrl: './cycle.html',
  styleUrl: './cycle.scss',
})
export class Cycle extends BaseHierarchicalCrudComponent<
  CycleProjectionDto,
  CycleCreateDto,
  CycleUpdateDto,
  CycleProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  geographicService = inject(CycleService);
  orchestratorService = inject(CycleProjectionPlanningOrchestratorService);
  service: ICrudService<
    CycleProjectionDto,
    CycleCreateDto,
    CycleUpdateDto,
    CycleProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('cycles', ids),
    getList: (query: GetCycleProjectionListInputDto) => this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.orchestratorService, 'cycleId'),
  };
  config = CYCLE_CONFIG;
  fields = CYCLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CycleProjectionDto): CycleUpdateDto {
    return {
      standLocationId: data.standLocationId,
      cycleValue: data.cycleValue,
      plantationDate: data.plantationDate,
      plantationArea: data.plantationArea,
      startDate: data.startDate,
      isOwnPlantation: data.isOwnPlantation,
      isLastCycle: data.isLastCycle,
      eucalyptusPercentage: data.eucalyptusPercentage,
      eucalyptusArea: data.eucalyptusArea,
      spacingId: data.spacingId,
      geneticMaterialId: data.geneticMaterialId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Cycle';
  }
}
